
import { MyFleetAemEndPoint } from 'projects/tmhna-portal/src/app/components/myfleet';
import { HeaderNavEndpoint } from 'projects/tmhna-portal/src/app/components/shell/shell.interface';
import { AuthEndpoint } from './auth/auth.interface';
import { DashboardEndpoint } from './dashboard';
import { RolesEndpoint } from './roles-permissions';
import { ServiceManagementEndpoint } from './service-management';


export interface Endpoints {
  auth: AuthEndpoint;
  roles: RolesEndpoint;
  header: HeaderNavEndpoint;
  myfleetlabels: MyFleetAemEndPoint;
  serviceManagement: ServiceManagementEndpoint;
  dashboard: DashboardEndpoint;
}
